import { makeStyles } from '@mui/styles';
import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { ASSIGNMENT_VIEW_TYPE } from 'types';
import { translate } from 'translations/translator';
const getTranslation = (key, options?) => translate('assignmentTracker', key, options);

export const AssignmentToggleNav = ({ selected, handleSelected }) => {
  const classes = useStyles();

  const ACTIVE_STYLES: any = {
    borderBottom: ' 4px solid #000000',
    color: '#000000',
    fontWeight: 'bold'
  };
  const DEFAULT_STYLES: any = {
    borderBottom: ' 1px solid #E0E0E0',
    color: '#6A6A6A',
    fontWeight: 'bold'
  };

  return (
    <ToggleButtonGroup
      onChange={(_, value) => handleSelected(value[0])}
      style={{ display: 'flex' }}
    >
      <ToggleButton
        size="large"
        className={classes.toggleBtn}
        value={ASSIGNMENT_VIEW_TYPE.ASSIGNMENTS}
        style={selected === ASSIGNMENT_VIEW_TYPE.ASSIGNMENTS ? ACTIVE_STYLES : DEFAULT_STYLES}
      >
        {getTranslation('tableTitle')}
      </ToggleButton>
      <ToggleButton
        size="large"
        className={classes.toggleBtn}
        value={ASSIGNMENT_VIEW_TYPE.MESSAGES}
        style={selected === ASSIGNMENT_VIEW_TYPE.MESSAGES ? ACTIVE_STYLES : DEFAULT_STYLES}
      >
        {getTranslation('messages')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

const useStyles = makeStyles(() => ({
  toggleBtn: {
    display: 'flex !important',
    flex: 1,
    textTransform: 'none !important',
    width: 100,
    borderTop: 'none !important',
    borderLeft: 'none !important',
    borderRight: 'none !important',
    '&:hover': {
      backgroundColor: 'unset !important'
    },
    '&:disabled': {
      border: 'none'
    }
  } as any
}));
